// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"theme--horizontal--1MJ9BTTN","vertical":"theme--vertical--xUlwzXOQ"};